/**
 * Where one delivered SOAP note opens in NDD's Healthie portal (NO-679): the
 * portal's private-notes edit address, confirmed on the Ticket. It is a path
 * the server resolves against the portal base address it chooses from
 * `HEALTHIE_API_URL` (`server/clinical-documentation/healthie-chart-note-url.ts`).
 * Only the production Healthie API maps to a base, so Staging and local
 * development have no base and
 * `GET /api/appointments/:appointmentId/documentation/healthie-note` answers
 * "not available yet" there.
 *
 * Placeholders, each replaced with the URI-encoded id the Writeback Intent
 * froze or the delivered attempt recorded:
 * - `{healthieNoteId}`: the delivered Healthie chart note, a FormAnswerGroup id.
 * - `{healthiePatientId}`: the Healthie Patient the intent targets.
 * - `{healthieAppointmentId}`: the Healthie Appointment the intent targets
 *   (supported, unused by the current address).
 *
 * The type stays `string | null`: setting it to null switches the link off
 * everywhere, leaving the delivered message as plain text and the
 * click-through answering "not available yet". The constant holds no ids, so
 * the client imports it to decide whether to render the link.
 */
export const HEALTHIE_CHART_NOTE_PATH_PATTERN: string | null =
  "/users/{healthiePatientId}/private_notes/edit/{healthieNoteId}";
